<template>
  <div @click="handleClick" class="step-btn" :class="{
        'step-btn--prev': type == 'prev',
        'step-btn--next': type == 'next',
        'step-btn--active': isActive
    }">
    <div class="step-btn-inner">
      {{value}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: '', //prev || next
    },
    value: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {
    handleClick() {
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss" scoped>
// @keyframes breath {
//   0% {
//     transform: translateY(-50%) scale(0.9);
//   }
//   100% {
//     transform: translateY(-50%) scale(1);
//   }
// }

// @keyframes breath2 {
//   0% {
//     transform: translateY(-50%) scale(0.9) rotate(-180deg);
//   }
//   100% {
//     transform: translateY(-50%) scale(1) rotate(-180deg);
//   }
// }

.step-btn {
  display: inline-block;
  vertical-align: middle;
  .step-btn-inner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('~@static/fundingnew_/lg-btn-bg.png') center center / contain no-repeat;
    width: pxtow(548);
    height: pxtow(127);
    font-size: pxtow(36);
    font-family: 'SourceHanSansCN-Heavy';
    font-weight: bold;
    color: #fff;
  }
  &.step-btn--active {
    .step-btn-inner{
      color: #fff100;
    }
  }
  &.step-btn--prev {
    .step-btn-inner {
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: pxtow(24);
        width: pxtow(80);
        height: pxtow(80);
        // animation: breath2 1s ease-in infinite alternate;
        background-image: url('~@static/fundingnew_/btn-sm-arrow.png');
        background-size: contain;
        background-repeat: no-repeat;
        transform: translateY(-50%) rotate(-180deg);
      }
    }
  }
  &.step-btn--next {
    .step-btn-inner {
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: pxtow(24);
        width: pxtow(80);
        height: pxtow(80);
        // animation: breath 1s ease-in infinite alternate;
        background-image: url('~@static/fundingnew_/btn-sm-arrow.png');
        background-size: contain;
        background-repeat: no-repeat;
        transform: translateY(-50%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/components/StepBtn.vue